"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-4">
        <li className="h-4 w-32 bg-muted animate-pulse" />
        <li className="h-4 w-28 bg-muted animate-pulse" />
        <li className="h-4 w-36 bg-muted animate-pulse" />
        <li className="h-4 w-24 bg-muted animate-pulse" />
      </ul>;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default font-normal text-base text-foreground hover:text-accent transition-colors duration-[220ms]" style={{
        letterSpacing: "-0.01em"
      }}>
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const elsewhereLinks = [{
    label: "Instagram",
    href: "#"
  }, {
    label: "Twitter",
    href: "#"
  }, {
    label: "YouTube",
    href: "#"
  }, {
    label: "Contact",
    href: "/Contact"
  }];
  return <section data-section-id="1605" id="site-footer" className="relative w-full pt-24 pb-8 font-default text-foreground bg-background">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center">
        <div className="flex-1 h-px bg-border" />
        <div className="h-1 w-1 bg-accent mr-0" />
      </div>

      <div className="max-w-[1280px] mx-auto px-8">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8">
          {}
          <div className="md:col-span-5">
            <h2 className="font-default text-foreground" style={{
            fontWeight: 700,
            fontSize: "clamp(2.5rem, 8vw, 5rem)",
            letterSpacing: "-0.02em",
            lineHeight: 1.1
          }}>
              Odd<em className="not-italic italic text-accent">hatter</em>
            </h2>
            <p className="mt-8 font-default font-normal text-muted-foreground max-w-sm" style={{
            fontSize: "16px",
            lineHeight: 1.5
          }}>
              An unapologetic digital playground for comedy and entertainment.
            </p>
          </div>

          {}
          <div className="md:col-span-3 md:col-start-7">
            <div className="font-mono uppercase text-muted-foreground mb-12" style={{
            fontSize: "12px",
            letterSpacing: "0.2em",
            lineHeight: 1.0
          }}>
              Index &mdash; Navigation
            </div>
            <MenuProvider menu_id="44">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-3 md:col-start-10">
            <div className="font-mono uppercase text-muted-foreground mb-12" style={{
            fontSize: "12px",
            letterSpacing: "0.2em",
            lineHeight: 1.0
          }}>
              Elsewhere &mdash; Social
            </div>
            <ul className="flex flex-col gap-4">
              {elsewhereLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="group inline-block font-default font-normal text-base text-foreground hover:text-accent transition-colors duration-[220ms]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-24 mb-12 h-px w-full bg-border" />

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            <p className="font-mono uppercase text-muted-foreground" style={{
            fontSize: "12px",
            letterSpacing: "0.2em",
            lineHeight: 1.0
          }}>
              &copy; 2024 Oddhatter LLC &middot; All Rights Reserved
            </p>
          </div>
          <div className="md:col-span-6 md:text-right">
            <p className="font-mono uppercase text-muted-foreground" style={{
            fontSize: "12px",
            letterSpacing: "0.2em",
            lineHeight: 1.0
          }}>
              Digital Playground &infin; Global
            </p>
          </div>
        </div>
      </div>
    </section>;
}